import React from "react";

/**
 * Иконки навигации (AUFB-67).
 *
 * Почему не эмодзи. В свёрнутом сайдбаре (60px) иконка — единственный признак,
 * по которому пункт опознаётся, а в эмодзи-наборе были дубли: 📊 стоял у трёх
 * разных пунктов, 📦 / 🛒 / 📈 — у двух каждый. Три одинаковых значка в колонке
 * делают свёрнутое меню неработоспособным.
 *
 * Плюс эмодзи рендерятся системным цветным шрифтом и не подчиняются
 * currentColor — на жёлтой плашке активного пункта они выглядят наклейкой.
 * Здесь stroke="currentColor", поэтому иконка сама принимает нужный цвет.
 *
 * Все контуры — 24×24, stroke-width 1.75, без заливки.
 */

const base = {
  width: 18,
  height: 18,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.75,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  "aria-hidden": true,
  focusable: false,
};

export const ICONS = {
  // ── Главная ──
  home: (
    <svg {...base}>
      <path d="M3 10.5 12 3l9 7.5" />
      <path d="M5 9.5V21h14V9.5" />
      <path d="M9.5 21v-6h5v6" />
    </svg>
  ),

  // ── Продажи ──
  /** Дашборд продаж — линия с точками */
  chartLine: (
    <svg {...base}>
      <path d="M3 3v18h18" />
      <path d="M7 15l4-5 3 3 5-7" />
      <circle cx="7" cy="15" r="1.2" />
      <circle cx="19" cy="6" r="1.2" />
    </svg>
  ),
  /** Онлайн продажи — корзина */
  cart: (
    <svg {...base}>
      <path d="M2.5 3h2.2l2.1 11.2a1.7 1.7 0 0 0 1.7 1.4h8.4a1.7 1.7 0 0 0 1.7-1.3l1.6-6.8H6" />
      <circle cx="9.5" cy="20" r="1.4" />
      <circle cx="17.5" cy="20" r="1.4" />
    </svg>
  ),
  /** Розничная касса — платёжный терминал */
  card: (
    <svg {...base}>
      <rect x="2.5" y="5.5" width="19" height="13" rx="2.2" />
      <path d="M2.5 10h19" />
      <path d="M6.5 14.5h3" />
    </svg>
  ),
  /** Опт — клиенты */
  users: (
    <svg {...base}>
      <circle cx="9" cy="8" r="3.2" />
      <path d="M2.8 20a6.2 6.2 0 0 1 12.4 0" />
      <path d="M16.5 5.2a3.2 3.2 0 0 1 0 5.9" />
      <path d="M18 14.4a6.2 6.2 0 0 1 3.2 5.6" />
    </svg>
  ),
  /** Опт — продажи (документы) */
  clipboard: (
    <svg {...base}>
      <rect x="5" y="4.5" width="14" height="17" rx="2" />
      <path d="M9 4.5V3.4A1.4 1.4 0 0 1 10.4 2h3.2A1.4 1.4 0 0 1 15 3.4v1.1" />
      <path d="M9 11h6M9 15h6" />
    </svg>
  ),

  // ── Магазины ──
  /** Смены по магазинам */
  clock: (
    <svg {...base}>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 7v5.3l3.4 2" />
    </svg>
  ),

  // ── Склад ──
  /** Дашборд склада — столбцы (отличается от chartLine) */
  chartBar: (
    <svg {...base}>
      <path d="M3 3v18h18" />
      <rect x="7" y="12" width="3" height="6" rx="0.8" />
      <rect x="12.5" y="8" width="3" height="10" rx="0.8" />
      <rect x="18" y="5" width="3" height="13" rx="0.8" />
    </svg>
  ),
  /** Товары — коробка */
  box: (
    <svg {...base}>
      <path d="M20.5 7.7v8.6a1.8 1.8 0 0 1-.95 1.6l-6.7 3.6a1.8 1.8 0 0 1-1.7 0l-6.7-3.6a1.8 1.8 0 0 1-.95-1.6V7.7" />
      <path d="M3.9 7 12 11.3 20.1 7 12 2.7z" />
      <path d="M12 11.3V21" />
    </svg>
  ),
  /** Остатки товара — слои (намеренно НЕ график) */
  layers: (
    <svg {...base}>
      <path d="M12 3 3 7.5l9 4.5 9-4.5z" />
      <path d="M3 12.5 12 17l9-4.5" />
      <path d="M3 17 12 21.5 21 17" />
    </svg>
  ),
  /** Возвраты */
  undo: (
    <svg {...base}>
      <path d="M3.5 8.5h11a5.5 5.5 0 0 1 0 11H8" />
      <path d="M7 4.5 3.5 8.5 7 12.5" />
    </svg>
  ),
  /** Склады — здание */
  warehouse: (
    <svg {...base}>
      <path d="M3 20V9.6a1.5 1.5 0 0 1 .9-1.37l7.5-3.3a1.5 1.5 0 0 1 1.2 0l7.5 3.3A1.5 1.5 0 0 1 21 9.6V20" />
      <path d="M2 20h20" />
      <rect x="8" y="13" width="8" height="7" rx="0.8" />
    </svg>
  ),
  /** Категории — ярлык */
  tag: (
    <svg {...base}>
      <path d="M3 11.3V4.5A1.5 1.5 0 0 1 4.5 3h6.8a1.5 1.5 0 0 1 1.06.44l8.2 8.2a1.5 1.5 0 0 1 0 2.12l-6.8 6.8a1.5 1.5 0 0 1-2.12 0l-8.2-8.2A1.5 1.5 0 0 1 3 11.3z" />
      <circle cx="7.8" cy="7.8" r="1.4" />
    </svg>
  ),
  /** Ревизия — документ с галочкой */
  checklist: (
    <svg {...base}>
      <path d="M19 12.5V6a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2h5" />
      <path d="M9 9h6M9 13h4" />
      <path d="M15 18.2l1.9 1.9 3.6-3.9" />
    </svg>
  ),
  /** Отчёт по ревизиям — документ с диаграммой */
  report: (
    <svg {...base}>
      <path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z" />
      <path d="M14 3v5h5" />
      <path d="M9 17v-3M12 17v-5M15 17v-2" />
    </svg>
  ),
  /** Перемещения — обмен */
  transfer: (
    <svg {...base}>
      <path d="M4 8h13l-3.2-3.2" />
      <path d="M20 16H7l3.2 3.2" />
    </svg>
  ),
  /** Запросы на закуп — пакет */
  purchase: (
    <svg {...base}>
      <path d="M4.5 8h15l-1.1 11.2a1.8 1.8 0 0 1-1.8 1.6H7.4a1.8 1.8 0 0 1-1.8-1.6z" />
      <path d="M8.8 8V6.2a3.2 3.2 0 0 1 6.4 0V8" />
    </svg>
  ),

  // ── Бухгалтерия ──
  /** Обзор — деньги */
  money: (
    <svg {...base}>
      <rect x="2.5" y="6" width="19" height="12" rx="2" />
      <circle cx="12" cy="12" r="2.6" />
      <path d="M6 9.5v5M18 9.5v5" />
    </svg>
  ),
  /** P&L — тренд вверх */
  trendUp: (
    <svg {...base}>
      <path d="M3 16.5l5.5-5.5 3.5 3.5L21 5.5" />
      <path d="M15.5 5.5H21v5.5" />
    </svg>
  ),
  /** Опт продажи (отчёт) — коробка со стрелкой */
  boxOut: (
    <svg {...base}>
      <path d="M20.5 10v6.3a1.8 1.8 0 0 1-.95 1.6l-6.7 3.6a1.8 1.8 0 0 1-1.7 0l-6.7-3.6a1.8 1.8 0 0 1-.95-1.6V10" />
      <path d="M3.9 9 12 13.3 20.1 9" />
      <path d="M12 2.5v7M12 2.5 9.5 5M12 2.5 14.5 5" />
    </svg>
  ),
  /** Онлайн продажи (отчёт) — витрина */
  storefront: (
    <svg {...base}>
      <path d="M3.5 9.5V20h17V9.5" />
      <path d="M2.5 9.5 4.3 4.4A1.5 1.5 0 0 1 5.7 3.4h12.6a1.5 1.5 0 0 1 1.4 1l1.8 5.1" />
      <path d="M9.5 20v-5.5h5V20" />
    </svg>
  ),

  // ── Управление ──
  /** Роли и права: щит с галочкой. */
  shield: (
    <svg {...base}>
      <path d="M12 3 4.5 6v5.5c0 4.4 3.1 8.2 7.5 9.5 4.4-1.3 7.5-5.1 7.5-9.5V6z" />
      <path d="m9 12 2.2 2.2L15.5 10" />
    </svg>
  ),
  /** Пользователи системы: один человек с ключом — не путать с `users` (оптовые клиенты). */
  userKey: (
    <svg {...base}>
      <circle cx="9" cy="8" r="3.5" />
      <path d="M2.5 20a6.5 6.5 0 0 1 10.3-5.3" />
      <circle cx="17.5" cy="15.5" r="2" />
      <path d="M17.5 17.5V21M17.5 19.5h2" />
    </svg>
  ),
  settings: (
    <svg {...base}>
      <circle cx="12" cy="12" r="3" />
      <path d="M19.4 15a1.6 1.6 0 0 0 .32 1.77l.06.06a1.9 1.9 0 1 1-2.7 2.7l-.05-.06a1.6 1.6 0 0 0-1.78-.32 1.6 1.6 0 0 0-1 1.47V21a1.9 1.9 0 1 1-3.8 0v-.1a1.6 1.6 0 0 0-1.05-1.47 1.6 1.6 0 0 0-1.77.32l-.06.06a1.9 1.9 0 1 1-2.7-2.7l.06-.06A1.6 1.6 0 0 0 4 15a1.6 1.6 0 0 0-1.47-1H2.4a1.9 1.9 0 0 1 0-3.8h.1A1.6 1.6 0 0 0 4 9.15a1.6 1.6 0 0 0-.32-1.78l-.06-.06a1.9 1.9 0 1 1 2.7-2.7l.06.06A1.6 1.6 0 0 0 8.15 5 1.6 1.6 0 0 0 9.15 3.5V3.4a1.9 1.9 0 1 1 3.8 0v.1a1.6 1.6 0 0 0 1 1.47 1.6 1.6 0 0 0 1.78-.32l.06-.06a1.9 1.9 0 1 1 2.7 2.7l-.06.06a1.6 1.6 0 0 0-.32 1.77V9.2a1.6 1.6 0 0 0 1.47 1h.1a1.9 1.9 0 0 1 0 3.8h-.1a1.6 1.6 0 0 0-1.47 1z" />
    </svg>
  ),

  /** Переключатель темы: солнце — «включить светлую». */
  sun: (
    <svg {...base}>
      <circle cx="12" cy="12" r="4" />
      <path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" />
    </svg>
  ),
  /** Луна — «включить тёмную». */
  moon: (
    <svg {...base}>
      <path d="M20.5 14.5A8.5 8.5 0 0 1 9.5 3.5a8.5 8.5 0 1 0 11 11z" />
    </svg>
  ),

  /** Ассистент — реплика диалога. */
  assistant: (
    <svg {...base}>
      <path d="M21 11.5a8.4 8.4 0 0 1-9 8.4 9.5 9.5 0 0 1-2.4-.3L4 21l1.4-4.2A8.2 8.2 0 0 1 3.6 11.5 8.4 8.4 0 0 1 12 3.1a8.4 8.4 0 0 1 9 8.4z" />
      <path d="M9 11h.01M12 11h.01M15 11h.01" />
    </svg>
  ),
  /** Очистить историю. */
  trash: (
    <svg {...base}>
      <path d="M4 6.5h16" />
      <path d="M9.5 6.5V4.8A1.3 1.3 0 0 1 10.8 3.5h2.4a1.3 1.3 0 0 1 1.3 1.3v1.7" />
      <path d="M6.5 6.5 7.4 19a1.6 1.6 0 0 0 1.6 1.5h6a1.6 1.6 0 0 0 1.6-1.5l.9-12.5" />
      <path d="M10.5 10.5v6M13.5 10.5v6" />
    </svg>
  ),
  /** Развернуть на весь экран. */
  expand: (
    <svg {...base}>
      <path d="M14 4h6v6M20 4l-7 7M10 20H4v-6M4 20l7-7" />
    </svg>
  ),
  /** Свернуть обратно. */
  collapse: (
    <svg {...base}>
      <path d="M20 10h-6V4M14 10l7-7M4 14h6v6M10 14l-7 7" />
    </svg>
  ),
  /** Отправить сообщение. */
  send: (
    <svg {...base}>
      <path d="M4.5 12h15M13 5.5 19.5 12 13 18.5" />
    </svg>
  ),
  /** Скачать файл. */
  download: (
    <svg {...base}>
      <path d="M12 3.5v11M8 11l4 3.5 4-3.5" />
      <path d="M4.5 17.5v1.6A1.4 1.4 0 0 0 5.9 20.5h12.2a1.4 1.4 0 0 0 1.4-1.4v-1.6" />
    </svg>
  ),

  /** Поиск. */
  search: (
    <svg {...base}>
      <circle cx="11" cy="11" r="7" />
      <path d="M20 20l-3.6-3.6" />
    </svg>
  ),

  // ── Служебные (шелл, таб-бар) ──
  menu: (
    <svg {...base}>
      <path d="M4 7h16M4 12h16M4 17h16" />
    </svg>
  ),
  close: (
    <svg {...base}>
      <path d="M6 6l12 12M18 6L6 18" />
    </svg>
  ),
  chevron: (
    <svg {...base}>
      <path d="M9 5l7 7-7 7" />
    </svg>
  ),
  logout: (
    <svg {...base}>
      <path d="M9 21H6a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3" />
      <path d="M16 17l5-5-5-5" />
      <path d="M21 12H9" />
    </svg>
  ),
};

/**
 * Иконка по ключу. Неизвестный ключ возвращается как есть, поэтому старый
 * формат (эмодзи прямо в navigation.js) продолжает работать и иконки можно
 * мигрировать по одной.
 */
export function navIcon(icon) {
  if (typeof icon === "string" && ICONS[icon]) return ICONS[icon];
  return icon || null;
}
